class FilterService {
    static hasNullEntries(input: Array<string>) {
        if (input === null || input.length === 0) {
            return false;
        }

        return input.some(x => this.hasNull(x));
    }

    static hasNull(input: string) {
        return /(?<=,\s*|^)null(?=\s*,|$)/.test(input);
    }
}